import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import add from '../../../img/add.svg';
import details from '../../../img/details.svg';

export default class TrainigsScreen extends React.Component {

    constructor(props) {
        super(props);

        var instituteid = null
        var selectedInstituteId = ""
        var programid = null
        var selectedProgramId = ""
        
        const args = props.args === undefined ? {} : props.args

        if (args.selectedInstituteId) {
            selectedInstituteId = args.selectedInstituteId
        }
    
        if (args.instituteid !== undefined) {
            instituteid = args.instituteid
            selectedInstituteId = instituteid
        }

        if (args.selectedProgramId) {
            selectedProgramId = args.selectedProgramId
        }

        if (args.programid !== undefined) {
            programid = args.programid
            selectedProgramId = programid
        }
       
        this.state = {args: args,
                      instituteOptions: [],
                      programOptions: [],
                      nameCriteria: "",
                      prevNameCriteria:"",
                      instituteId: instituteid,
                      selectedInstituteId: selectedInstituteId,
                      programId: programid,
                      selectedProgramId: selectedProgramId,
                      trainings: []};

              

        this.nameSearch = this.nameSearch.bind(this);  
        this.institutionChangeHandler = this.institutionChangeHandler.bind(this); 
        this.programChangeHandler = this.programChangeHandler.bind(this); 

        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        
        setTimeout(this.nameSearch, 2000);
    }

    componentDidMount() {
        this.getInstituteOptons() 
        this.getProgramOptons() 
        this.getDataWithCritera()
    }

    institutionChangeHandler(selectedOption) {
        var args = this.state.args
        args.selectedInstituteId = selectedOption.value
        this.setState({selectedInstituteId: selectedOption.value, args: args}, this.getDataWithCritera)
    }


    programChangeHandler(selectedOption) {
        var args = this.state.args
        args.selectedProgramId = selectedOption.value
        this.setState({selectedProgramId: selectedOption.value, args: args}, this.getDataWithCritera)
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {

            this.setState({prevNameCriteria: this.state.nameCriteria}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    getInstituteOptons() {
        BaseApi.get("/institutions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const instituteOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            instituteOptions.push({value: "", label: "Все"})
            this.setState({instituteOptions: instituteOptions})
        })    
        .catch()
    }

    getProgramOptons() {
        BaseApi.get("/programs", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            const programOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            programOptions.push({value: "", label: "Все"})
            this.setState({programOptions: programOptions})
        })    
        .catch()
    }

    getDataWithCritera() {

        var parameters = {}

        if (this.state.selectedInstituteId.length > 0) {
            parameters.instituteid = this.state.selectedInstituteId
        }

        if (this.state.selectedProgramId.length > 0) {
            parameters.programid = this.state.selectedProgramId
        }
       
        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        BaseApi.get('/trainings', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({trainings: res.data})
        })    
        .catch(error=>console.log(error))
    }    

    openTraining(id) {
        this.props.navigate("training", {caller: "trainings", callargs: this.state.args, training: id})
    }

    renderTraining(training) {
    
        return (
            <div class="row" style={{"height" : "50px"}}>
                    {this.state.instituteId === null &&
                    <div class="col-2 text-left border border-white" style={{"background-color" : "#eee"}}>{training.institution}</div>
                    }
                    {this.state.programId === null &&
                        <div class="col-2 text-left border border-white" style={{"background-color" : "#eee"}}>{training.program}</div>
                    }
                    <div class="col-3 text-left border border-white" style={{"background-color" : "#eee"}}>{training.name}</div>
                    <div class="col-2 text-left border border-white" style={{"background-color" : "#eee"}}>{training.start}</div>
                    <div class="col-2 text-left border border-white" style={{"background-color" : "#eee"}}>{training.end}</div>
                    <div class="col-1 border border-white"  style={{"background-color" : "#eee"}} onClick={()=>this.openTraining(training.id)}><img src={details} height="16" width="16"/></div>
            </div>
        )        
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Обучения"}/>
                <div class="mt-5 col-md-4">
                    <form title="Фильтр">
                        <div class="form-group">
                            <label for="name"> Имя:</label>
                            <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                            {this.state.instituteId === null && 
                            <div> 
                            <label for="institution">Учреждение:</label>
                            <Select options= {this.state.instituteOptions} 
                                    id="institution" 
                                    onChange={this.institutionChangeHandler}
                                    />
                            </div>     
                            }  
                            {this.state.programId === null && 
                            <div> 
                            <label for="program">Программа:</label>
                            <Select options= {this.state.programOptions} 
                                    id="program" 
                                    onChange={this.programChangeHandler}
                                    />
                            </div>     
                            }              
                        </div>
                    </form>
                </div>
                <div class="row" style={{"height" : "50px"}}>
                    {this.state.instituteId === null &&
                        <div class="col-2 text-left border border-white" 
                             style={{"background-color" : "#0ee"}}>Учреждение
                        </div>
                     }
                     {this.state.programId === null &&
                        <div class="col-2 text-left border border-white" 
                             style={{"background-color" : "#0ee"}}>Программа
                        </div>
                     }    
                    <div class="col-3 text-left border border-white"
                         style={{"background-color" : "#0ee"}}>Название
                    </div>
                    <div class="col-2 text-left border border-white"
                         style={{"background-color" : "#0ee"}}>
                         Начало
                    </div>
                    <div class="col-2 text-left border border-white"
                         style={{"background-color" : "#0ee"}}>
                         Завершение
                    </div>
                    <div class="col-1 border border-white"
                         id="detailCaptuon" 
                         style={{"background-color" : "#0ee"}}
                         onClick={()=>{this.openTraining("")}}>
                         <img src={add} height="16" width="16"/>
                    </div>     
                </div>    
                {this.state.trainings.map((value, index) => this.renderTraining(value))}
            </div> 
        )
    }



}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/training/trainings.js